import { memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { PropsWithTestId } from '../../props';

export type GlowTextFieldProps = React.ComponentPropsWithRef<'input'> & PropsWithTestId;

export const GlowTextField: ComponentMemo<GlowTextFieldProps> = memo(({ className, dataTestId, ...props }) => {
    return <input className={clsx('text-body font-brand', className)} {...props} data-testid={dataTestId} />;
});

GlowTextField.displayName = 'GlowTextField';
